// Loads Google reCAPTCHA (v2 checkbox) on demand, at most once per page, and resolves with
// window.grecaptcha. render=explicit defers widget creation to the caller's
// grecaptcha.render call; onload fires once api.js has finished loading. The host is the
// same one the server-rendered not_robot / contact_us reCAPTCHA already loads, so no new
// domains are introduced. Shared by the inline BotChallenge component.
const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=__botChallengeRecaptchaLoaded';

let recaptchaLoadPromise = null;

const ensureRecaptchaLoaded = () => {
  if (window.grecaptcha && window.grecaptcha.render) {
    return Promise.resolve(window.grecaptcha);
  }
  if (recaptchaLoadPromise) {
    return recaptchaLoadPromise;
  }

  recaptchaLoadPromise = new Promise((resolve, reject) => {
    window.__botChallengeRecaptchaLoaded = () => { resolve(window.grecaptcha); };
    const script = document.createElement('script');
    script.src = RECAPTCHA_SCRIPT_SRC;
    script.async = true;
    script.defer = true;
    script.onerror = () => {
      // Let a later challenge retry the load instead of caching the failure forever.
      recaptchaLoadPromise = null;
      reject(new Error('recaptcha_script_failed'));
    };
    document.head.appendChild(script);
  });

  return recaptchaLoadPromise;
};

export default ensureRecaptchaLoaded;
